import { ReferenceData } from './reference-data.model';
import { SelectableSearchOption } from './selectable-search-option';

export class SelectableReferenceData extends ReferenceData implements SelectableSearchOption {
  public Selected: boolean;
}
